export default {
  root: ({ orgConfig }) => ({
    "&.user-top-banner": {
      backgroundColor: orgConfig.theme.primary || "#00b2a4"
    }
  })
};
